<div class="card-header">
  @if (isSelected) {
    <div class="bubble">
      <icon name="check"></icon>
    </div>
  }
  <div class="flex column">
    <h4>{{effectiveFP.Name}}</h4>
    <p>{{effectiveFP.NeighborhoodName}}</p>
  </div>

  <div class="flex row align-center push-right">
    @if (effectiveFP.IsInventoryHome) {
      <hc-ih-badge></hc-ih-badge>
    }

    @if (indexInList && listTotal > 1) {
      <div class="index">
        <b>{{indexInList}} </b>/ {{listTotal}}
      </div>
    }
  </div>
</div>
<div class="card-body">
  <gallery [images]="galleryImages" [disableFavoriting]="true">
  </gallery>

  <div class="container">
    <div class="flex row align-center justify-between">
      @if (effectiveFP.Price || effectiveFP.PriceRange) {
        <p>Base Price <b>{{effectiveFP.PriceDisplay}}</b></p>
      }
      @if (effectiveFP.AssociatedLots.length) {
        <p>{{lotLabelPlural}} Available: <b>{{effectiveFP.AssociatedLots.length}}</b></p>
      }
    </div>

    @if (!isSelected) {
      <button class="hc-btn primary fp-select-btn" (click)="floorplanSelect.emit()" aria-label="Select Floor Plan">Select
      {{theme.fpLabel}}</button>
    }
    @if (listTotal > 1 && isSelected) {
      <button class="hc-btn primary fp-select-btn success">
        <icon name="check"></icon>
        Selected
      </button>
    }
    @if (listTotal === 1 && isSelected) {
      <button class="hc-btn negative fp-select-btn" (click)="floorplanChange.emit()"
        aria-label="Change Floor Plan">
        <icon name="arrows_switch"></icon>
        Change {{theme.fpLabel}}
      </button>
    }

    <floorplan-specs [fp]="effectiveFP" [forceNonCollapsible]="true" [showPrice]="false"></floorplan-specs>
  </div>
</div>